import { atom } from 'recoil';
import { FirebaseDataStatus } from '~/types/utilities';

const globalDataStatus = atom({
  key: 'globalDataStatus',
  default: {
    cart: FirebaseDataStatus.INIT,
    platform: FirebaseDataStatus.INIT,
    remotePickMealPoints: FirebaseDataStatus.INIT,
  },
});

export default globalDataStatus;
